import { Directive, HostBinding } from '@angular/core';

@Directive({
    selector: 'ui-figure-sub-text'
})
export class UiFigureSubTextDirective {
    @HostBinding('class') elClass = 'ui-figure-sub-text';
}
